import {Component, ViewChild} from '@angular/core';
import {MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger} from '@angular/material/legacy-autocomplete';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {FormControl} from '@angular/forms';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {AdminApi} from '../../admin/admin-api';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {MatLegacyOption as MatOption} from '@angular/material/legacy-core';


@Component({
   selector: 'app-share',
   templateUrl: './share.component.html',
   styleUrls: ['./share.component.css']
})
export class ShareComponent {

   public indexSelected = 0;
   shareId: any;
   objectId: any;
   objectType = '';
   errorMessage: any;
   buttonUser = false;
   buttonGroup = false;
   buttonSite = false;
   contactId: any;
   groupId = '0';

   membersShare: User[] = [];
   shareUser: User[] = [];
   groupShare: Group[] = [];
   shareGroup: Group[] = [];
   siteShare: Site[] = [];
   shareSites: Site[] = [];

   myControlUser = new FormControl();
   myControlGroup = new FormControl();
   myControlSite = new FormControl();

   userData: User[] = [];
   groupData: Group[] = [];
   siteData: Site[] = [];
   searchsUser: any;
   searchsGroup: any;
   searchSite: any;
   checkUser: any;
   checkGroup: any;
   checkSite: any;
   submitCheck: boolean;
   searchFocused: boolean;
   showMessage = false;
   searchMessage = '';
   private timer: any;

   @ViewChild('contactOptUser') contactOptUser: MatOption;
   @ViewChild('contactOptGroup') contactOptGroup: MatOption;
   @ViewChild('contactOptSite') contactOptSite: MatOption;
   @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
   @ViewChild('cont', {read: MatAutocompleteTrigger, static: true}) cont: MatAutocompleteTrigger;
   @ViewChild('contGroup', {read: MatAutocompleteTrigger, static: true}) contGroup: MatAutocompleteTrigger;
   @ViewChild('contSites', {read: MatAutocompleteTrigger, static: true}) contSites: MatAutocompleteTrigger;

   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;

   constructor(public toast: Toast,
               public service: IdexService, public translate: TranslateService, private api: AdminApi,
               private dialogRef: MatDialogRef<ShareComponent>) {
   }

   highlightFirstOptionUser(event, input: any): void {
      this.cont.openPanel();
      this.userData = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      const kw = input.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         this.timer = setTimeout(() => {
            this.timer = null;
            if (kw.length > 0) {
               this.service.searchUserShare(encodeURIComponent(kw), this.contactId)
                  .subscribe(
                     data => {
                        if (this.timer == null) {
                           this.userData = data;
                           this.matAutocomplete._keyManager.setFirstItemActive();
                        }
                     }, error => {
                        this.errorMessage = error;
                     });
            } else {
               this.userData = null;
            }
         }, 300);
      }
   }

   highlightFirstOptionGroup(event, input: any): void {
      this.contGroup.openPanel();
      this.groupData = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      const kw = input.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         this.timer = setTimeout(() => {
            this.timer = null;
            if (kw.length > 0) {
               this.service.searchGroupShare(encodeURIComponent(kw), this.groupId)
                  .subscribe(
                     data => {
                        if (this.timer == null) {
                           this.groupData = data;
                           this.matAutocomplete._keyManager.setFirstItemActive();
                        }
                     }, error => {
                        this.errorMessage = error;
                     });
            } else {
               this.groupData = null;
            }
         }, 300);
      }
   }

   highlightFirstOptionSite(event, input: any): void {
      this.contSites.openPanel();
      this.siteData = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      const kw = input.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         this.timer = setTimeout(() => {
            this.timer = null;
            if (kw.length > 0) {
               this.service.searchSiteShare(encodeURIComponent(kw))
                  .subscribe(
                     data => {
                        if (this.timer == null) {
                           this.siteData = data;
                           this.matAutocomplete._keyManager.setFirstItemActive();
                        }
                     }, error => {
                        this.errorMessage = error;
                     });
            } else {
               this.siteData = null;
            }
         }, 300);
      }
   }

   displayUser(contact?: User): string | undefined {
      let name: any;
      if (contact !== null && contact !== undefined && contact.name !== undefined) {
         name = contact ? contact.name : '';
      } else {
         name = contact ? contact : '';
      }
      return contact ? name : '';
   }

   displayGroup(group?: Group): string | undefined {
      let groups: any;
      if (group !== null && group !== undefined && group.groupName !== undefined) {
         groups = group ? group.groupName : '';
      } else {
         groups = group ? group : '';
      }
      return group ? groups : '';
   }

   displaySite(site?: Site): string | undefined {
      let siteName: any;
      if (site !== null && site !== undefined && site.name !== undefined) {
         siteName = site ? site.name : '';
      } else {
         siteName = site ? site : '';
      }
      return site ? siteName : '';   }

   selectContactShare(evt: any, contactOpt: any, cont: any): void {
      if (evt.source && evt.source.selected && cont.value !== '') {
         for (const i of this.membersShare) {
            if (i.id === contactOpt.contactId) {
               break;
            }
         }
         this.buttonUser = true;
         this.checkUser = contactOpt;
         this.searchsUser = contactOpt;
         contactOpt.value = [];
      }
   }

   selectContactgroup(evt: any, contactOpt: any, cont: any): void {
      if (evt.source && evt.source.selected && cont.value !== '') {
         for (const i of this.groupShare) {
            if (i.groupId === contactOpt.groupId) {
               break;
            }
         }
         this.buttonGroup = true;
         this.checkGroup = contactOpt;
         this.searchsGroup = contactOpt;
         contactOpt.value = [];
      }
   }

   selectContactSite(evt: any, contactOpt: any, cont: any): void {
      if (evt.source && evt.source.selected && cont.value !== '') {
         for (let i = 0; i < this.siteShare.length; i++) {
            if (this.siteShare[i].id === contactOpt.id) {
               break;
            }
         }
         this.buttonSite = true;
         this.checkSite = contactOpt;
         this.searchSite = contactOpt;
         contactOpt.value = [];
      }
   }

   addButtonUser() {
      if (this.buttonUser) {
         if (this.membersShare.length > 0) {
            if (this.checkDuplicate()) {
               this.translate.get('alert.duplicate_username').subscribe(s => {
                  this.toast.error(s);
               });
            } else {
               this.membersShare.push(this.checkUser);
               this.shareUser.push(this.checkUser.email);
            }
         } else {
            this.membersShare.push(this.checkUser);
            this.shareUser.push(this.checkUser.email);
         }
         this.searchsUser = '';
         this.buttonUser = false;
         this.userData = [];
      }
   }

   addButtonGroup() {
      if (this.buttonGroup) {
         if (this.groupShare.length > 0) {
            if (this.checkDuplicateGroup()) {
               this.translate.get('alert.duplicate_group').subscribe(s => {
                  this.toast.error(s);
               });
            } else {
               this.groupShare.push(this.checkGroup);
               this.shareGroup.push(this.checkGroup.groupName);
            }
         } else {
            this.groupShare.push(this.checkGroup);
            this.shareGroup.push(this.checkGroup.groupName);
         }
         this.searchsGroup = '';
         this.buttonGroup = false;
         this.groupData = [];
      }
   }

   addButtonSite() {
      if (this.buttonSite) {
         if (this.siteShare.length > 0) {
            if (this.checkDuplicateSite()) {
               this.translate.get('alert.duplicate_site').subscribe(s => {
                  this.toast.error(s);
               });
            } else {
               this.siteShare.push(this.checkSite);
               this.shareSites.push(this.checkSite.id);
            }
         } else {
            this.siteShare.push(this.checkSite);
            this.shareSites.push(this.checkSite.id);
         }
         this.searchSite = '';
         this.buttonSite = false;
         this.siteData = [];
      }
   }

   deleteUser(member: any) {
      const index: number = this.membersShare.indexOf(member);
      if (index !== -1) {
         this.membersShare.splice(index, 1);
         this.shareUser.splice(index, 1);
      }
   }

   deleteGroup(member: any) {
      const index: number = this.groupShare.indexOf(member);
      if (index !== -1) {
         this.groupShare.splice(index, 1);
         this.shareGroup.splice(index, 1);
      }
   }

   deleteSite(member: any) {
      const index: number = this.siteShare.indexOf(member);
      if (index !== -1) {
         this.siteShare.splice(index, 1);
         this.shareSites.splice(index, 1);
      }
   }

   exit(cont: any) {
      this.dialogRef.close(true);
   }

   LoadGroupTabs(event) {
      const indexSelected = event.index;
      if (indexSelected === 0) {
         this.groupData = [];
         this.siteData = [];
         this.searchsGroup = '';
         this.searchSite = '';
         this.buttonGroup = false;
         this.buttonSite = false;
         this.searchFocused = false;
      } else if (indexSelected === 1) {
         this.userData = [];
         this.siteData = [];
         this.searchsUser = '';
         this.searchSite = '';
         this.buttonUser = false;
         this.buttonSite = false;
         this.searchFocused = false;
      } else if (indexSelected === 2) {
         this.userData = [];
         this.groupData = [];
         this.searchsUser = '';
         this.searchsGroup = '';
         this.buttonUser = false;
         this.buttonGroup = false;
         this.searchFocused = false;
      }
   }

   submit() {
      if (this.shareId > '0' || this.submitCheck === true) {
         this.service.updateShareId(this.shareUser, this.shareGroup, this.shareSites, this.shareId)
            .subscribe(
               (res) => {
                  this.dialogRef.close(true);
               });
      } else {
         this.service.addShareId(this.objectId, this.objectType, this.shareUser, this.shareGroup, this.shareSites)
            .subscribe(
               (res) => {
                  this.dialogRef.close(true);
               });
      }
   }

   unshare() {
      this.service.unshare(this.objectId, this.objectType)
         .subscribe(
            (res) => {
               this.dialogRef.close(true);
            },
            error => {
               this.dialogRef.close();
            });
   }

   checkDuplicate() {
      for (const i of this.membersShare) {
         if (i.email === this.checkUser.email) {
            return true;
         }
      }
   }

   checkDuplicateGroup() {
      for (const i of this.groupShare) {
         if (i.groupId != null) {
            if (i.groupId === this.checkGroup.groupId) {
               return true;
            }
         } else { if (i.groupName === this.checkGroup.groupName) {return true; }
         }
      }
   }

   checkDuplicateSite() {
      for (const i of this.siteShare) {
         if (i.id === this.checkSite.id || i.tin === this.checkSite.id) {
            return true;
         }
      }
   }

   onSearchFocus() {
      this.searchFocused = true;
   }
   onSearchBlur() {
      setTimeout(() => {
         this.searchFocused = false;
      }, 300);
   }
}

export class User {
   constructor(public id: number, public fullName: string, public email: string, public name: string) {
   }
}

export class Group {
   constructor(public groupId: number, public groupName: string, public itemName: string, public active: boolean) {
   }
}

export class Site {
   constructor(public id: number, public tin: number, public name: string) {
   }
}
